import MessageModal from "components/shared-components/MessageModal";
import {
  useCheckRole,
  useCopyTransferOrder,
  useCreateTransferOrder,
} from "hooks";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import TransferOrderForm from "./TransferOrderForm";

const TransferOrderPage = props => {
  const { t } = useTranslation(["order"]);
  const navigate = useNavigate();
  const location = useLocation();
  const { isHubAdmin } = useCheckRole();
  // const { is_send_order } = location?.state;
  const { is_copy = false } = props;

  const [openPopup, setOpenPopup] = useState(false);
  const [orderCode, setOrderCode] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [messagePopups, setMessagePopups] = useState([]);

  const toggleModalNotify = () => {
    setOpenPopup(!openPopup);
    handleCancel();
  };

  const handleNavigate = () => {
    if (isHubAdmin) {
      navigate(
        location?.state?.is_send_order
          ? "/manage-orders-active"
          : "/manage-transfer-orders"
      );
    } else {
      navigate(-1);
    }
  };

  const onSuccessCreateOrder = _data => {
    if (_data.shipping_type === 3 || customerCode === "GSNEW") {
      setOrderCode(_data.order_code);
      const mes = [];
      if (_data.shipping_type === 3) {
        mes.push({
          value: t("message.note", {
            order_code: _data.order_code,
          }),
          class: "",
        });
      }
      if (customerCode === "GSNEW") {
        mes.push({
          value: t("message.note_create_GSNEW"),
          class: "text-danger",
        });
      }
      setMessagePopups(mes);
      setOpenPopup(true);
    } else if (_data.shipping_type === 2) {
      const mes = [];
      mes.push({
        value: t("message.note_shipping_type"),
        class: "",
      });
      setMessagePopups(mes);
      setOpenPopup(true);
    } else {
      handleNavigate();
    }
  };

  const onSuccessCopyOrder = () => {
    navigate("/manage-transfer-orders");
  };

  const { mutate: mutateCreateOrder, isLoading: isLoadingCreateOrder } =
    useCreateTransferOrder(onSuccessCreateOrder);

  const { mutate: mutateCopyOrder, isLoading: isLoadingCopyOrder } =
    useCopyTransferOrder(onSuccessCopyOrder);

  const handleCreateOrder = data => {
    setCustomerCode(data.customer_code);
    mutateCreateOrder(data);
  };

  const handleCopyOrderMutate = (orderId, data) => {
    mutateCopyOrder({ orderId, data });
  };

  const handleCancel = () => {
    handleNavigate();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MessageModal
          isOpen={openPopup}
          autoFocus={true}
          centered={true}
          toggle={toggleModalNotify}
          clickOutsideNotClose={true}
          type={"infor"}
          // message={t('message.note', {
          //   order_code: orderCode
          // })}
          messages={messagePopups}
        ></MessageModal>

        <Container fluid={true}>
          <TransferOrderForm
            isHCMOrder={false}
            handleCreateOrder={handleCreateOrder}
            handleCancel={handleCancel}
            isLoadingSubmit={isLoadingCreateOrder}
            is_copy={is_copy}
            isLoadingCopyOrder={isLoadingCopyOrder}
            handleCopyOrderMutate={handleCopyOrderMutate}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TransferOrderPage;
